import Vue from 'vue';
import i18n from '@/libs/i18n';

export default i18n; 